export const config = {
    api: {
        localUrl: 'http://127.0.0.1:8001',
        paths: {
            auth: '/api/admin/me',
            mapsKey: '/api/admin/maps-config',
            content: '/api/content',
            contentExpertise: '/api/content/expertise',
            contentImage: '/api/content/image',
            contentVideo: '/api/content/video',
            contentDocument: '/api/content/file_document',
            documentDownload: '/api/file_document',
            certificates: '/api/blocks/certificates',
            media: '/api/media',
            blocks: '/api/blocks',
            blocksByParent: '/api/blocks/by-parent',
            deleteBlock: '/api/blocks',
            reorderBlocks: '/api/blocks/reorder',
            contactForm: '/api/contact-form',
            // News API endpoints
            news: '/api/news',
            newsById: '/api/news',
            newsBySlug: '/api/news/slug',
            newsByBlockId: '/api/news/block',
            newsLinkBlock: '/api/news',
            newsPublish: '/api/news',
            newsStatus: '/api/news',
            blocksByPage: '/api/blocks/by-page',
            newsPublishedTop: '/api/news/published/top',
            newsOffset: '/api/news/list/offset',
            // Cases API endpoints (separate from news)
            cases: '/api/cases',
            casesBySlug: '/api/cases/slug',
            casesByBlockId: '/api/cases/block',
            casesLinkBlock: '/api/cases',
            casesPublish: '/api/cases',
            casesOffset: '/api/cases/list/offset',
            caseFixPageTitles: '/api/cases/admin/fix-page-titles',
            // Vacancies API endpoints
            vacancies: '/api/vacancies',
            vacanciesById: '/api/vacancies',
            vacanciesBySlug: '/api/vacancies/slug',
            vacanciesByBlockId: '/api/vacancies/block',
            vacanciesLinkBlock: '/api/vacancies',
            vacanciesPublish: '/api/vacancies',
            vacanciesActive: '/api/vacancies/published/active',
            vacanciesOffset: '/api/vacancies/list/offset',
            vacancyForm: '/api/vacancy-form',
            // Courses API endpoints
            courses: '/api/courses',
            coursesById: '/api/courses',
            coursesBySlug: '/api/courses/slug',
            coursesByBlockId: '/api/courses/block',
            coursesLinkBlock: '/api/courses',
            coursesPublish: '/api/courses',
            coursesActive: '/api/courses/published/active',
            coursesOffset: '/api/courses/list/offset',
            courseForm: '/api/course-form',

            doctorsWithContent: '/api/blocks/doctors-with-content',
            // Diagnostics API endpoints
            diagnostics: '/api/diagnostics',
            diagnosticsBySlug: '/api/diagnostics/slug',
            diagnosticsByBlockId: '/api/diagnostics/block',
            diagnosticsLinkBlock: '/api/diagnostics'
        }
    },
    carousel: {
        autoScroll: true,
        autoScrollDelay: 5000,
        maxVisibleCards: 4,
        cardGap: 24,
        minCardWidth: 200,
        selectors: {
            cardsContainer: '[data-section="carousel"]',
            card: '.carousel-item, .diagnostic-card, .diagnostic-step-item, .doctor-card',
            navigation: '.carousel-navigation',
            container: '.carousel-container'
        }
    },
    accordion: {
        selectors: {
            accordionContainer: '[data-section="accordion"]',
            caseRow: '.row',
            imageContainer: '.image-container',
            caseImage: '.case-image',
            title: 'h4',
            description: 'p'
        }
    },
    editor: {
        publishBtnDelay: 3000,
        selectors: {
            publishButton: 'publish-button'
        }
    }
};

export function getApiBaseUrl() {
    return (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
        ? config.api.localUrl
        : window.location.origin;
}

export function getBlockApiUrl(blockId) {
    return `${config.api.paths.blocks}/${blockId}`;
}

export function getNewsApiUrl(newsId, action = '') {
    const baseUrl = `${config.api.paths.news}/${newsId}`;
    return action ? `${baseUrl}/${action}` : baseUrl;
}

export function getCoursesApiUrl(courseId, action = '') {
    const baseUrl = `${config.api.paths.courses}/${courseId}`;
    return action ? `${baseUrl}/${action}` : baseUrl;
}